import * as React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { Layout } from 'components/Layout/Layout';
import { ReduxState } from 'ducks';

import styles from './ReviewLayout.module.css';

type Props = {
  children: React.ReactNode;
};

export const ReviewLayout = ({ children }: Props) => {
  const { t } = useTranslation();
  const settings = useSelector((state: ReduxState) => state.server.settings.all);

  return (
    <Layout>
      <header className={styles['post-header']}>
        <div className={styles['post-header__inner']}>
          <div className={styles['post-header__inner__logo']}>
            {settings.logo_url && <img src={settings.logo_url} />}
          </div>
          <div className={styles['post-header__inner__txt']}>
            {settings.supplier_address && (
              <p>
                {t('Address')}: {settings.supplier_address}
              </p>
            )}
            {settings.supplier_phone && <p>TEL: {settings.supplier_phone}</p>}
          </div>
        </div>
      </header>
      <main className={styles['post-main']}>{children}</main>
    </Layout>
  );
};
